/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );

      $( 'button.easy-toggle-fade-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).fadeToggle();
      } );

      $( '#primary-nav' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget === null ) return;
        const reltarget = $( event.relatedTarget );
        const currenttarget = $( event.currentTarget );

        if ( !reltarget.closest( '#primary-nav' ).is( currenttarget ) && ( $( reltarget ).get( 0 ) !== $( '.navbar-toggle' ).get( 0 ) ) ) {
          $( '.navbar-toggle' ).trigger( 'click' );
        }
      } );

      $( document ).on( 'click', '.js-init-video', function( e ) {
        e.preventDefault();
        // get the title from data attribute added to button
        const title = $( e.currentTarget ).data( 'title' );
        $.magnificPopup.open( {
          items: {
            src: $( this ).attr( 'href' ),
          },
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              // get the current instance of the magnificPopup
              const currentMagnificPopup = $.magnificPopup.instance;

              // add title to the container aria label
              currentMagnificPopup.contentContainer.attr( 'role', 'dialog' );

              if ( title !== undefined ) {
                // get the current iframe element
                const currIframe = currentMagnificPopup.currTemplate.iframe.find( 'iframe' );
                // add title to the iframe and container
                currIframe.prop( 'title', title );
                currentMagnificPopup.contentContainer.attr( 'aria-label', `${title} player` );
              }

              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      $( '.js-init-content' ).magnificPopup( {
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      } );

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '#ll-body' ).toggleClass( 'is-open' );
      } );

      if ( !window.isMobile ) {
        $( '.primary-menu-item:first-of-type > button' ).trigger( 'click' );
        $( '.primary-menu-item:first-of-type > .child-menu > ul li:first-of-type button' ).trigger( 'click' );
      }

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      /* allows File Upload input to update name when file is uploaded */
      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload .ll-file-details' );
          $( theInput ).text( filename );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      /* ADA - make sure image link is not in tab index since we are using title like to make whole card clickable */
      $( '.mec-event-image a' ).each( function() {
        $( this ).attr( 'tabindex', -1 );
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      /* disable duplicate entries on form submit */
      $( document ).on( 'submit', '.form-skin', function() {
        // Disable submit button
        $( this ).find( 'button[type="submit"]' ).prop( 'disabled', true ).css( 'opacity', 0.2 );
      } );
    },
    finalize: function() {
    },
    Throttle: class Throttle {
      constructor( callback, delay ) {
        this.callback = callback;
        this.delay = delay;
        this.throttlePause = false;
        this.waitingArgs = null;
        this.timeoutFunc = this.timeoutFunc.bind( this );
      }
      run( ...args ) {
        if ( this.throttlePause ) {
          this.waitingArgs = args;
          return;
        }
        this.callback( ...args );
        this.throttlePause = true; // Set throttle pause state for this instance
        setTimeout( this.timeoutFunc, this.delay );
      }
      timeoutFunc() {
        if ( this.waitingArgs ) {
          this.callback( ...this.waitingArgs );
          this.waitingArgs = null;
          setTimeout( this.timeoutFunc, this.delay );
        } else {
          this.throttlePause = false;
        }
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
